export default __webpack_public_path__ + "static/media/card-thumbnail.40bae069.png";